export default __webpack_public_path__ + "static/media/coupons_close.52daf146.svg";